export const MAX_VISIBLE_GROUPS = 4;
export const FACEBOOK_ID = 'facebook';
export const FACEBOOK_DISPLAY = 'Facebook';
export const TWITTER_DISPLAY = 'Twitter';
export const LINKEDIN_DISPLAY = 'LinkedIn';
